import { render } from "./DynamicUpdate.vue?vue&type=template&id=9a7d8a3a&scoped=true"
import script from "./DynamicUpdate.vue?vue&type=script&lang=js"
export * from "./DynamicUpdate.vue?vue&type=script&lang=js"

import "./DynamicUpdate.vue?vue&type=style&index=0&id=9a7d8a3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7d8a3a"]])

export default __exports__